import filter from '@/api/filter';
export const config = {
  data() {
    return {
      columns: []
    };
  },
  mounted() {
    this.getColumns();
  },
  methods: {
    getColumns() {
      const columns = [
        {
          title: '出单机构/团队/业务员',
          slot: 'userName',
          align: 'center',
          minWidth: 300,
          show: true
        },
        {
          title: '投保人姓名',
          key: 'policyerName',
          align: 'center',
          width: 120,
          show: true
        },
        {
          title: '保险公司',
          key: 'companyName',
          align: 'center',
          minWidth: 120,
          show: true
        },
        {
          title: '投保产品',
          key: 'productName',
          align: 'center',
          minWidth: 200,
          show: true
        },
        {
          title: '保单号',
          key: 'policyNo',
          align: 'center',
          minWidth: 160,
          show: true
        },
        {
          title: '失败原因',
          key: 'describe',
          align: 'center',
          width: 140,
          show: this.status == '1-2'
        },
        {
          title: '邮寄单号',
          key: 'mailOrderNo',
          align: 'center',
          width: 140,
          show: this.status == '1-3'
        },
        {
          title: '完成日期',
          key: 'finishDate',
          align: 'center',
          width: 140,
          render(h, params) {
            const res = params.row.finishDate;
            return h('div', filter.filterTime(res, 'YYYY-MM-DD'));
          },
          show: this.status == '1-3'
        },
        {
          title: '申请时间',
          key: 'createTime',
          align: 'center',
          width: 140,
          show: true,
          render(h, params) {
            const res = params.row.createTime;
            return h('div', filter.filterTime(res, 'YYYY-MM-DD HH:mm'));
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 100,
          show: true,
        }
      ];

      this.columns = columns.filter(item => item.show);
    }
  }
};
